import { gql } from '@apollo/client'
import { ProductLineSummaryItem } from 'ts/interfaces/productLineSummary.interface'
import { ProductDetailsSourceProduct } from 'ts/interfaces/productsDetails.interface'

export const GET_EDIT_PAGE_DETAILS = gql`
  query GetEditPageDetails($dealId: Int!) {
    editPageDetails(dealId: $dealId) {
      errorMessage
      isSuccess
    }
  }
`

export const GET_CACHE_EDIT_PAGE_DETAILS = gql`
  query GetCacheEditPageDetails($dealId: Int!) {
    cacheEditPageDetails(dealId: $dealId) {
      errorMessage
      isSuccess
      dealHeaderInformation {
        isoCurrencyCode
      }
      combinedFlatProducts {
        product {
          lineNumber
          lineTypeCode
          productGenericNumberText
          productGenericDescriptionText
          assosiatePlCode
          estimatedQuantity
          totalDiscountRequestPercentage
          totalDiscountRequestPercentageUpdated
          extendedRequestBdNet
          requestBdNetPriceAmount
          requestBdNetPriceAmountUpdated
          requestNetMarginPercentage
          requestNetMarginPercentageUpdated
          authBdnetPriceAmount
          authBdnetPriceAmountUpdated
          authNetMarginPercentage
          authNetMarginPercentageUpdated
          totalDiscountAuthPercentage
          totalDiscountAuthPercentageUpdated
          guidanceExpertPercentage
          guidanceFloorPercentage
          guidanceTypicalPercentage
          calcGuidanceFloorPercentage
          calcGuidanceExpertPercentage
          calcGuidanceTypicalPercentage
          historicalMedianDiscountPercentage
          historicalBottom25DiscountPercentage
          historicalTop25DiscountPercentage
        }
      }
      plTotalDynamicResponse {
        totalNetRevenue
        totalDiscountPercentage
        totalOGMPercentage
        plTotalDynamic {
          productLineCode
          plDescription
          estimatedPnBdNetRevenue
          estimatedDiscountPercentage
          estimatedDiscountPercentageUpdated
          netMarginPercentage
          busGroupCode
          plCategoryCd
          expertDiscountPercentage
          floorDiscountPercentage
          typicalDiscountPercentage
          updatedCm
          cm
          __typename
        }
      }
      dealCubeHistoryProductDetails {
        dealCubeHistoryDetails {
          dealId
          level
          approversByLevel {
            roleTitle
            decisionReasonCode
          }
          productDetails {
            lineNumber
            itemNumber
            scaleId
            totalDiscountPercentage
            bdNet
            netRevenue
          }
          productlineDetails {
            productLineCode
            netMarginPercentage
            estimatedDiscountPercentage
            netRevenue
          }
        }
      }
      totalBdNetPriceAmount
      totalEstimatedQuantity
    }
  }
`

export interface EditPageDetailsResponse {
  editPageDetails: {
    errorMessage: string | null
    isSuccess: boolean
  }
}

export interface GetCacheEditPageDetailsResponse {
  cacheEditPageDetails: {
    errorMessage: string | null
    isSuccess: boolean
    dealHeaderInformation: {
      isoCurrencyCode: string
    }
    combinedFlatProducts: Array<{
      product: ProductDetailsSourceProduct
    }>
    plTotalDynamicResponse: {
      totalNetRevenue: number
      totalDiscountPercentage: number
      totalOGMPercentage: number
      plTotalDynamic: Array<
        ProductLineSummaryItem & {
          updatedCm: number | null
          cm: number | null
          estimatedDiscountPercentageUpdated: number | null
          expertDiscountPercentage: number | null
          floorDiscountPercentage: number | null
          typicalDiscountPercentage: number | null
        }
      >
    } | null
    dealCubeHistoryProductDetails: {
      dealCubeHistoryDetails: Array<{
        dealId: number
        level: string | number
        approversByLevel: Array<{
          roleTitle: string
          decisionReasonCode: string
        }>
        productDetails: Array<{
          lineNumber: number
          itemNumber: number
          scaleId: number
          totalDiscountPercentage: number
          bdNet: number
          netRevenue: number
        }>
        productlineDetails: Array<{
          productLineCode: string
          netMarginPercentage: number
          estimatedDiscountPercentage: number
          netRevenue: number
        }>
      }>
    } | null
    totalBdNetPriceAmount: number
    totalEstimatedQuantity: number
  }
}
